<div class="share-checkbox-container">
  <div class="section-text" fiTranslation="REQUEST_DETAIL_HEADER_EDIT_HEADER_SHARE_OPTION_HEADLINE"></div>

  <fi-checkbox
    class="lead-shared-checkbox checkbox"
    [ngModelOptions]="{standalone: true}"
    [ngModel]="checked"
    [disabled]="disabled"
    (ngModelChange)="onValueChange($event)"
  >
    <div class="checkbox-label" fiTranslation="REQUEST_DETAIL_HEADER_EDIT_HEADER_SHARE_OPTION_LABEL"></div>
    <div class="checkbox-description" fiTranslation="REQUEST_DETAIL_HEADER_EDIT_HEADER_SHARE_OPTION_DESCRIPTION"></div>
  </fi-checkbox>
</div>
